<template>
  <div>

  </div>
</template>

<script>
import api from '@/api';
import { USER_ROLES } from '@/config';

export default {
  async mounted() {
    if(this.$route.query.token) {
      let response = await api.userAutoLogin(this.$route.query.token);
      console.log('response', response);
      if(response.status === 200) {
        const authDetails = {};
        authDetails.role = USER_ROLES.USER;
        authDetails.token = response.data.token;
        authDetails.user_id = response.data.user_id;
        const isAdmin = response.data.is_admin;
        const isStaff = response.data.is_staff;

        if (authDetails.token && isAdmin) {
          authDetails.role = USER_ROLES.ADMIN;
        } else if (authDetails.token && isStaff) {
          authDetails.role = USER_ROLES.STAFF;
        }

        // Store data in local storage
        localStorage.setItem('auth_details', JSON.stringify(authDetails));
        localStorage.setItem('refresh_token', this.$route.query.token);
        this.$store.commit('setAuthDetails', authDetails);
      }
      this.$router.push({
        name: 'VideoMode',
        query: {
          pid: this.$route.query.pid,
          sid: this.$route.query.sid,
          did: this.$route.query.did,
        },
      })
    }
  }
}
</script>